// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Ip-z","imageAndVideoCount":"Jp-z","imageAndVideoContainer":"Kp-z","viewAllReviews":"Lp-z"};